import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "fileInput", "fileName", "uploadButton"]
  static values = { url: String }

  connect() {
    this.setupDropzone()
  }

  setupDropzone() {
    const dropzone = this.dropzoneTarget

    // Prevent default drag behaviors
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropzone.addEventListener(eventName, this.preventDefaults, false)
      document.body.addEventListener(eventName, this.preventDefaults, false)
    })

    // Highlight drop area when item is dragged over it
    ['dragenter', 'dragover'].forEach(eventName => {
      dropzone.addEventListener(eventName, () => this.highlight(), false)
    })

    ['dragleave', 'drop'].forEach(eventName => {
      dropzone.addEventListener(eventName, () => this.unhighlight(), false)
    })

    // Handle dropped files
    dropzone.addEventListener('drop', (e) => this.handleDrop(e), false)
  }

  preventDefaults(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  highlight() {
    this.dropzoneTarget.classList.add('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20')
    this.dropzoneTarget.classList.remove('border-slate-300', 'dark:border-slate-600')
  }

  unhighlight() {
    this.dropzoneTarget.classList.remove('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20')
    this.dropzoneTarget.classList.add('border-slate-300', 'dark:border-slate-600')
  }

  handleDrop(e) {
    const dt = e.dataTransfer
    const files = dt.files
    this.handleFiles(files)
  }

  handleFiles(files) {
    if (files.length > 0) {
      const file = files[0]
      this.fileInputTarget.files = files
      this.displayFileName(file.name)
      this.enableUploadButton()
    }
  }

  // Handle file selection via click
  fileSelected() {
    const file = this.fileInputTarget.files[0]
    if (file) {
      this.displayFileName(file.name)
      this.enableUploadButton()
    }
  }

  displayFileName(name) {
    if (this.hasFileNameTarget) {
      this.fileNameTarget.textContent = name
      this.fileNameTarget.classList.remove('hidden')
    }
  }

  enableUploadButton() {
    if (this.hasUploadButtonTarget) {
      this.uploadButtonTarget.disabled = false
      this.uploadButtonTarget.classList.remove('bg-slate-300', 'dark:bg-slate-600', 'text-slate-500', 'dark:text-slate-400', 'cursor-not-allowed')
      this.uploadButtonTarget.classList.add('bg-primary-500', 'hover:bg-primary-600', 'text-white', 'cursor-pointer')
    }
  }

  // Trigger file input click
  triggerFileInput() {
    this.fileInputTarget.click()
  }

  // Handle form submission
  upload() {
    if (this.fileInputTarget.files.length > 0) {
      const formData = new FormData()
      formData.append('file', this.fileInputTarget.files[0])
      
      // Get the authenticity token
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      formData.append('authenticity_token', token)

      this.uploadButtonTarget.disabled = true
      this.uploadButtonTarget.textContent = 'Uploading...'

      fetch(this.urlValue, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (response.ok) {
          window.location.reload()
        } else {
          throw new Error('Upload failed')
        }
      })
      .catch(error => {
        console.error('Error:', error)
        alert('Upload failed. Please try again.')
        this.uploadButtonTarget.disabled = false
        this.uploadButtonTarget.textContent = 'Import'
      })
    }
  }
}
